import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 5.833H14.5M4.1 9.362H8.866M2.367 3.233H13.633C14.112 3.233 14.5 3.621 14.5 4.1V11.9C14.5 12.379 14.112 12.767 13.633 12.767H2.367C1.888 12.767 1.5 12.379 1.5 11.9V4.1C1.5 3.621 1.888 3.233 2.367 3.233Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCreditCard;
